import React, { useState } from 'react';

export default function InfoDot({ msg }) {
	const [ open, setOpen ] = useState(false);

	return <div style={{ display: 'inline-block', overflow: 'visible', position: 'relative' }}>
		{open && <div className="tooltip">{msg}</div>}
		<span onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} className="fa fa-info-circle info-dot" />
	</div>;
}